let sessionStore
const clearListeners = new Set()

export function registerSessionStore(store) { sessionStore = store }
export function onSessionCleared(listener) { clearListeners.add(listener) }

export function clearSession() {
  localStorage.removeItem('authorizedAIToken')
  sessionStore?.commit('LOGOUT')
  clearListeners.forEach(listener => listener())
}

export function handleUnauthorized(error) {
  if (error?.response?.status !== 401) return
  const sent = error.config?.headers?.Authorization
  const current = localStorage.getItem('authorizedAIToken')
  // A late 401 from the previous account must not log out a freshly signed-in user.
  if (current && sent && sent !== `Bearer ${current}`) return
  clearSession()
  if (!['/login', '/prime-english'].includes(window.location.pathname)) window.location.assign('/login')
}
